// extracted by mini-css-extract-plugin
export default {"container":"Al-z","item":"Bl-z"};